var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ww-open-data',{ref:"wwOpenData",attrs:{"type":_vm.type,"openid":_vm.openid}})}
var staticRenderFns = []

export { render, staticRenderFns }